<template>
  <div class="checkRecord">
    <OATable :data="data" :columns="columns" :filterData="filterData" @search="handleSearch" :loading="loading">
    </OATable>
  </div>
</template>
<script>
  import checkApi from "@/services/check.js";
  import OAHandle from "@/components/OAHandle/OAHandle";

  export default {
    name: "checkRecord",
    components: {
      OAHandle
    },
    data() {
      let that = this;
      return {
        filterData: {
          companyId: {
            formType: "a-select",
            value: undefined,
            placeholder: "所属公司",
            col: 4,
            api: "getCompany",
            props: {
              label: "companyName",
              value: "id"
            },
            options: []
          },
          departIds: {
            formType: "a-depart-cascader",
            value: undefined,
            placeholder: "所在部门",
            col: 4,
            options: []
          },
          employeeId: {
            formType: "a-auto-search",
            value: undefined,
            apiType: "getUnder",
            col: 4,
            placeholder: "姓名工号"
          },
          toworkStatus: {
            formType: "a-select",
            value: undefined,
            placeholder: "上午考勤状态",
            code: 141,
            col: 4,
            options: []
          },
          offdutyStatus: {
            formType: "a-select",
            value: undefined,
            placeholder: "下午考勤状态",
            code: 141,
            col: 4,
            options: []
          },
          attendanceDate: {
            formType: "a-date-picker",
            type: "daterange",
            value: undefined,
            startPlaceholder: "开始时间",
            endPlaceholder: "结束时间",
            col: 4
          }
        },
        columns: [{
            title: "公司",
            key: "companyName",
            minWidth: "200"
          },
          {
            title: "工号",
            key: "employeeNumber"
          },
          {
            title: "姓名",
            minWidth: "80",
            key: "employeeName"
          },
          {
            title: "部门",
            key: "departName",
            minWidth: "100"
          },
          {
            title: "日期",
            key: "attendanceDate",
            sortable: "custom",
            minWidth: "100"
          },
          {
            title: "上班打卡时间",
            key: "timeTowork",
          },
          {
            title: "考勤状态",
            key: "toworkStatusName"
          },
          {
            title: "下班打卡时间",
            key: "timeOffduty",
          },
          {
            title: "考勤状态",
            key: "offdutyStatusName"
          },
          {
            title: "操作",
            key: "",
            minWidth: 110,
            component: {
              name: OAHandle,
              props: {
                text: "查看打卡记录",
                onClick: function (val) {
                  that.viewRecord(val.row.id);
                }
              }
            }
          }
        ],
        data: [],
        loading: false
      };
    },
    mounted() {},
    methods: {
      async handleSearch(val) {
        this.loading = true;
        if (!val.sortType || !val.sortName) {
          val["sortName"] = "attendanceDate";
          val["sortType"] = "descending";
        }
        let res = await checkApi.getCheckRecord(val);
        this.data = res.data.data;
        this.loading = false;
      },
      async viewRecord(id) {
        let res = await checkApi.getTime({
          id: id
        });
        let data = res.data.data;
        let message = "";
        if (data.length) {
          data.map(item => {
            message += item.distinguishBetween + "：" + item.clockTime + "<br/>";
          });
        } else {
          message = "暂无数据";
        }
        this.$msgbox({
          message: message,
          center: true,
          showConfirmButton: false,
          callback: action => {},
          dangerouslyUseHTMLString: true,
          customClass: "messageCheck"
        });
      }
    }
  };

</script>
<style lang="scss">
  .messageCheck {
    padding-bottom: 0px;
    width: auto;

    p {
      font-size: 18px;
      line-height: 30px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/self/checkRecord.vue